import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { allReservationsAction } from "../../redux/actions/reservationActions"
import { useSearchParams } from 'react-router-dom';

const Filters = ({ page, setPage, dateFrom, dateTo }) => {


    const dispatch = useDispatch()

    const { user } = useSelector(state => state.verifyEmailStore);



    const [perPage, setPerPage] = useState('10');
    const [seller_id, setSeller_id] = useState('');
    const [productID, setProductId] = useState('');

    const [searchParams, setSearchParams] = useSearchParams();






    useEffect(() => {

        const query = {}
        if (dateFrom) query.dateFrom = dateFrom
        if (dateTo) query.dateTo = dateTo
        if (seller_id) query.seller_id = seller_id
        if (productID) query.productID = productID
        if (perPage) query.perPage = perPage
        query.page = page


        setSearchParams(query)

        dispatch(allReservationsAction(query))

    }, [dateFrom, dateTo, seller_id, productID, perPage, page, dispatch, setSearchParams])





    useEffect(() => {

        setPerPage(searchParams.get("perPage") || "10")
        setSeller_id(searchParams.get("seller_id") || "")
        setProductId(searchParams.get("productID") || "")
        setPage(Number(searchParams.get("page")) || 1)


    }, [searchParams, setPage])



    return (
        <Fragment>
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center my-[2vmax] gap-[1.5vmax]">
                <div className="flex items-center gap-[1vmax]">
                    <div className="h-[2.5vmax] w-[0.4vmax] bg-indigo-600 rounded-full"></div>
                    <h2 className="text-[2.2vmax] lg:text-[1.3vmax] font-bold text-gray-800">Reservations Overview</h2>
                </div>

                <div className="flex items-center gap-[1.5vmax] bg-white p-[0.6vmax_1.2vmax] rounded-xl shadow-sm border border-gray-100">
                    <span className='text-[1.4vmax] lg:text-[0.9vmax] text-gray-500 font-medium'>Items per page:</span>
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.3vmax_0.8vmax] rounded-lg transition-all hover:border-indigo-300">
                        <i className="fa-solid fa-list-ul text-indigo-500 text-[1.2vmax] lg:text-[1vmax]"></i>
                        <select
                            className="pl-[0.8vmax] w-fit text-[1.4vmax] lg:text-[0.9vmax] font-semibold text-gray-700 outline-none bg-transparent cursor-pointer"
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(e.target.value)
                                setPage(1)
                            }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="bg-white p-[1.5vmax] shadow-sm rounded-t-2xl border border-gray-100 border-b-0">
                <div className="flex flex-wrap items-center gap-[1.5vmax]">
                    <div className="flex items-center gap-2 px-3 py-1 bg-indigo-50 text-indigo-600 rounded-full text-[0.8vmax] font-bold uppercase tracking-wider">
                        <i className="fa-solid fa-filter"></i>
                        <span>Filter By</span>
                    </div>

                    <div className="flex-1 min-w-[200px] lg:max-w-[200px] relative group">
                        <i className="fa-solid fa-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500 transition-colors"></i>
                        <input
                            type="text"
                            className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all text-[1.2vmax] lg:text-[0.9vmax] font-medium"
                            placeholder="Search Product ID..."
                            value={productID}
                            onChange={(e) => {
                                setProductId(e.target.value)
                                setPage(1)
                            }}
                        />
                    </div>

                    {user?.role !== 'PMM' &&
                        <div className="flex-1 min-w-[200px] lg:max-w-[200px] relative group">
                            <i className="fa-solid fa-user-tag absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500 transition-colors"></i>
                            <input
                                type="text"
                                className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all text-[1.2vmax] lg:text-[0.9vmax] font-medium"
                                placeholder="Search Seller ID..."
                                value={seller_id}
                                onChange={(e) => {
                                    setSeller_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    }
                </div>
            </div>

        </Fragment>
    )
}

export default Filters